import { getEnvVariable } from "../../modules/environmentalList";

const drawerexternal = {
    "type": "drawer",
    "order": 2,
    "key": "drawer",
    "options": {
        "alignitem": "left",
        // "title": "drawer",
        "icon": "alarm",
        "open": true,
        "anchor": 'left',
        "admin": 'N',
        "items": [{
            "type": "tree",
            "title": "Dashboard",
            "materialicon": "dashboard",
            "key": "Dashboard",
            "items": [
                {
                    "type": "menu",
                    "title": "Notifications",
                    "icon": "notifications_active",
                    "materialicon": "notifications_active",
                    "link": "/notifications",
                    "key": "Notifications",
                    "style": {
                        'color': '#d50000'
                    }
            },
            {
                "type": "menu",
                "title": "Invoice Dashboard",
                "icon": "assessment",
                "materialicon": "assessment",
                "link": "/billingdashboard",
"reloadtab": true,
                "key": "billingdashboard",
                "style": {
                    'color': '#c158dc'
                }
            },
            
            // {
            //     "type": "recordmenu",
            //     "title": "Records",
            //     "materialicon": "source",
            //     "key": "Records",
            //     "items" :[],
            //     "lskey": "submodule"
            // },

            ]

        },
        // {
        //     "type": "menu",
        //     "title": "Reports",
        //     "icon": "fa fa-files-o",
        //     "link": getEnvVariable('ReportsUI'),
        //     "key": "reports",
        //     "newtab": true,
        //     "materialicon": "post_add",
        //     "style": {
        //         'color': '#1a237e'
        //     }
        //     },       
        {
            "type": "tree",
            "title": "My Portal",
            "materialicon": "corporate_fare",
            "key": "MyPortal",
            "items": [
                {
                    "type": "menu",
                    "title": "Search",
                    "icon": "search",
                    "materialicon": "search",
                    "link": "/search",
"reloadtab": true,
                    "key": "Search",
                    "style": {
                        'color': '#61A5DC'
                    }
                },  
                {
                    "type": "recordmenu",
                    "title": "Records",
                    "materialicon": "source",
                    "key": "Records",
                    "items": [],
                    "lskey": "submodule"
                },
                {
                    "type": "menu",
                    "title": "Users",
                    "icon": "fa fa-users",
                    "link": "/users",
                    "key": "usersform",
                    "materialicon": "supervised_user_circle",
                    "style": {
                        'color': '#01579b'
                    }
                },
                // {
                //     "type": "menu",
                //     "title": "Contacts",
                //     "key": "contacts",
                //     "link": "/Administration/externalcontacts",
                //     "icon": "fa fa-user-circle-o",
                //     "materialicon": "portrait",
                //     "style": {
                //         'color': '#006064'
                //     }
                // },  
                {
                    "type": "menu",
                    "title": "Reports",
                    "icon": "fa fa-files-o",
                    "link": getEnvVariable('ReportsUI'),
                    "key": "reports",
                    "newtab": true,
                    "materialicon": "post_add",
                    "style": {
                        'color': '#827717'
                    }
                },   
                        
            ]
        }          
        ]
    }
}

export default drawerexternal